import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
// Component
import Avatar from '../../Avatar';
import { openReportUserModal } from '../../../actions/modalActions';
import { ReportFlagSvgIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';
// Locale
import messages from '../../../locale/jsonMessages';
import verificationIcon from '/public/SiteIcons/g648.svg'
import reviewsIcon from '/public/SiteIcons/user-details-star.svg'
import Link from '../../Link/Link';
import cs from '../../commonStyle.css'
import s from '../ViewMessage.css';

const UserDetail = (props) => {

  const isAdminAuthenticated = useSelector(state => state?.runtime?.isAdminAuthenticated);
  const isAuthenticated = useSelector(state => state?.runtime?.isAuthenticated);

  const dispatch = useDispatch();

  const { profileId, picture, displayName, location, verifications, reviewsCount, userType } = props;
  const { formatMessage } = useIntl();
  let totalVerification = 0;
  if (verifications) {
    if (verifications.isEmailConfirmed) { totalVerification += 1; }
    // if (verifications.isFacebookConnected) { totalVerification += 1; }
    if (verifications.isGoogleConnected) { totalVerification += 1; }
    if (verifications.isIdVerification == 1) { totalVerification += 1; }
  }
  return (
    <div className="">
      <hr class={s.horizondalLine} />
      <div className={cx(s.messageMainContainer)}>
        <div className={s.messageAvatar}>
          <Avatar
            source={picture}
            title={displayName}
            className={s.profileAvatar}
            withLink
            linkClassName={s.userDetailsImgContainer}
            profileId={profileId}
          />
        </div>
        <div className={cx(s.userDetailsInfo, s.userDetailsMarginLeft, 'userDetailsMarginLeftRTL')}>
          <div>
            <span className={cx(s.ownedByText)}>
              {<FormattedMessage {...messages[userType == 'owner' ? 'rentBy' : 'hostedBy']} />}{" "}
            </span>
            <a href={"/users/show/" + profileId} target={'_blank'} className={cx(s.userDetailsName)}>{displayName}</a>
          </div>
          <div className={cx(s.verificationFlexContainer, s.verificationBotAlignment)}>
            {/* <span>{location}</span> */}
            <span className={cx(s.verificationFlexBox)}>
              <img src={verificationIcon} className={cx()} alt="verified Icon" />
              <span className={cx(s.marginLeft, s.verificationText, 'marginLeftRTL')}>{totalVerification} {totalVerification > 1 ? formatMessage(messages.verifications) : formatMessage(messages.verification)}</span>
            </span>
            {/* <span>&nbsp;/&nbsp;</span> */}
            <span className={cx(s.dotCss)}></span>
            <span className={cx(s.verificationFlexBox, s.marginTop6Mobile)}>
              <img src={reviewsIcon} className={cx(s.verificationStarIcon)} alt="reviews Icon" />
              <span className={cx(s.marginLeft, s.verificationText, 'marginLeftRTL')}>{reviewsCount} {reviewsCount > 1 ? formatMessage(messages.reviews) : formatMessage(messages.review)}</span>
            </span>
          </div>
          {!isAdminAuthenticated && isAuthenticated &&
            <div
              className='reportUserProfile'
              onClick={() => dispatch(openReportUserModal())}
            >
              <ReportFlagSvgIcon />
              <FormattedMessage {...messages.reportUser} />
            </div>
          }
        </div>
      </div>
    </div>
  );
}

UserDetail.propTypes = {
  formatMessage: PropTypes.any,
  profileId: PropTypes.number.isRequired,
  picture: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  location: PropTypes.string,
  reviewsCount: PropTypes.number,
  verifications: PropTypes.shape({
    isEmailConfirmed: PropTypes.bool,
    isFacebookConnected: PropTypes.bool,
    isGoogleConnected: PropTypes.bool,
  }),
};

UserDetail.defaultProps = {
  picture: null,
  displayName: '',
  location: '',
};

export default withStyles(cs, s)(UserDetail);

